import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import MobileStickyBar from '../components/common/MobileStickyBar';
import { Check, ChevronDown, ArrowRight, AlertTriangle, Heart, Camera, Music, Clock, MapPin, Users } from 'lucide-react';

const RETRO = [
  { mois: '12 mois avant', items: ['Définir budget global', 'Choisir la date', 'Réserver la salle / domaine', 'Faire la liste invités (première estimation)'] },
  { mois: '9 mois avant', items: ['Réserver le photographe et vidéaste', 'Réserver le DJ ou groupe live', 'Sélectionner le traiteur', 'Fixer le thème et les couleurs'] },
  { mois: '6 mois avant', items: ['Envoyer les save-the-date', 'Réserver les animations Show Événement', 'Choisir la décoration et fleuriste', 'Essayages et tenues'] },
  { mois: '3 mois avant', items: ['Envoyer les invitations avec lien RSVP', 'Finaliser le menu traiteur', 'Commander la pièce montée', 'Préparer le déroulé de la journée'] },
  { mois: '1 mois avant', items: ['Confirmer tous les prestataires', 'Faire le point RSVP', 'Préparer le plan de table', 'Confirmer horaires livraison Show Événement'] },
  { mois: 'Semaine J', items: ['Répétition cérémonie', 'Derniers détails décoration', 'Confirmer reprise matériel Show Événement', 'Préparer sac de secours'] },
];

const CHECKLIST = [
  { cat: 'Salle & Lieu', items: ['Salle réservée et contrat signé', 'Accès PMR vérifié', 'Parking prévu', 'Plan B pluie (barnum)', 'Hébergement nuit de noces'] },
  { cat: 'Cérémonie', items: ['Officiant réservé', 'Micro sans fil', 'Déroulé cérémonie écrit', 'Musique cérémonie choisie', 'Vin d\'honneur organisé'] },
  { cat: 'Animations Show Événement', items: ['Photobooth réservé', 'Éclairage LED ambiance', 'Arche ballons sur-mesure', 'Sono & micro pour discours', 'Coin enfants (si familles)'] },
  { cat: 'Food & Boissons', items: ['Traiteur confirmé', 'Menu validé', 'Allergies collectées', 'Bar vin d\'honneur', 'Pièce montée / gâteau'] },
  { cat: 'Invités', items: ['Invitations envoyées', 'RSVP clôturé', 'Plan de table validé', 'Marque-places créés', 'Transport invités prévu'] },
  { cat: 'Jour J', items: ['Planning heure par heure', 'Contacts prestataires notés', 'Témoin chargé des imprévus', 'Photos souvenirs organisées'] },
];

const ERREURS = [
  { e: 'Tout vouloir gérer seul', c: 'Déléguer à vos témoins et au wedding planner. Vous devez profiter de votre Jour J !' },
  { e: 'Sous-estimer le budget', c: 'Prévoir 15-20% d\'imprévus. Les coûts s\'accumulent toujours.' },
  { e: 'Réserver trop tard', c: 'Bons photographes, DJ et domaines partent 12 à 18 mois à l\'avance.' },
  { e: 'Oublier l\'éclairage', c: 'L\'éclairage transforme une salle ordinaire. C\'est souvent l\'investissement le plus visible.' },
  { e: 'Pas de plan B météo', c: 'Pour un mariage en extérieur : barnum ou solution repli obligatoire.' },
  { e: 'Négliger le timing', c: 'Prévoir 30-45min de marge par rapport au planning officiel. Tout prend plus de temps.' },
];

function FAQItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="rounded-2xl overflow-hidden cursor-pointer" style={{ border: '1px solid var(--border)', background: '#FFF' }}>
      <button className="w-full flex items-center justify-between px-5 py-4 text-left gap-4" onClick={() => setOpen(!open)}>
        <span className="font-semibold text-sm" style={{ color: 'var(--ink)' }}>{q}</span>
        <ChevronDown size={16} style={{ color: '#D4AF37', flexShrink: 0, transform: open ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s' }} />
      </button>
      {open && <div className="px-5 pb-4"><p className="text-sm" style={{ color: 'var(--text-muted)', lineHeight: '1.7' }}>{a}</p></div>}
    </div>
  );
}

export default function GuideMariagePage() {
  const [checkItems, setCheckItems] = useState(
    CHECKLIST.flatMap(c => c.items.map(item => ({ label: item, cat: c.cat, done: false })))
  );

  const progress = Math.round(checkItems.filter(i => i.done).length / checkItems.length * 100);

  return (
    <div style={{ background: 'var(--bg)', minHeight: '100vh' }}>
      <Header />

      {/* HERO */}
      <section className="relative overflow-hidden" style={{ minHeight: '60vh' }}>
        <img src="https://images.unsplash.com/photo-1767986012138-d02276728368?w=1400&q=85"
          alt="Guide Mariage" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0" style={{ background: 'linear-gradient(135deg, rgba(11,30,32,0.88) 0%, rgba(11,30,32,0.5) 60%, transparent 100%)' }} />
        <div className="relative container-ose flex flex-col justify-end pb-12" style={{ minHeight: '60vh', paddingTop: '5rem' }}>
          <nav className="flex items-center gap-2 text-xs mb-4" style={{ color: 'rgba(255,255,255,0.6)' }}>
            <Link to="/guides" style={{ color: '#D4AF37' }}>Guides</Link>
            <span>/</span>
            <span style={{ color: '#FFF' }}>Mariage</span>
          </nav>
          <span className="inline-block w-fit px-4 py-2 rounded-full text-xs font-bold mb-4"
            style={{ background: 'rgba(212,175,55,0.2)', color: '#D4AF37', border: '1px solid rgba(212,175,55,0.4)' }}>
            💍 Guide complet Mariage 2026
          </span>
          <h1 className="font-display text-4xl sm:text-5xl font-bold mb-3"
            style={{ color: '#FFF', letterSpacing: '-0.03em', maxWidth: '700px', lineHeight: '1.05' }}>
            Organiser son mariage parfaitement
          </h1>
          <p className="text-sm mb-6 max-w-2xl" style={{ color: 'rgba(255,255,255,0.75)', lineHeight: '1.75' }}>
            Rétroplanning 12 mois, checklist 30 points, budget, prestataires, déroulé Jour J et les erreurs à éviter.
          </p>
          <div className="flex flex-wrap gap-3">
            <a href="#retro" className="inline-flex items-center gap-2 px-6 py-3 rounded-xl font-bold text-sm"
              style={{ background: '#D4AF37', color: '#0B1E20' }}>
              <Clock size={16} /> Voir le rétroplanning
            </a>
            <Link to="/creer-evenement" className="inline-flex items-center gap-2 px-6 py-3 rounded-xl font-semibold text-sm"
              style={{ background: 'rgba(255,255,255,0.12)', color: '#FFF', backdropFilter: 'blur(8px)', border: '1px solid rgba(255,255,255,0.2)' }}>
              Créer mon devis mariage <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </section>

      {/* BARRE PROGRÈS */}
      <div style={{ background: '#0B1E20', borderBottom: '1px solid rgba(212,175,55,0.2)' }}>
        <div className="container-ose py-3 flex items-center gap-4">
          <p className="text-xs font-semibold" style={{ color: '#D4AF37' }}>Préparation : {progress}%</p>
          <div className="flex-1 h-2 rounded-full overflow-hidden" style={{ background: 'rgba(255,255,255,0.1)' }}>
            <div className="h-full rounded-full transition-all" style={{ width: `${progress}%`, background: 'linear-gradient(90deg, #D4AF37, #1F9D7A)' }} />
          </div>
        </div>
      </div>

      {/* RÉTROPLANNING */}
      <section id="retro" className="section-py section-white">
        <div className="container-ose">
          <div className="text-center mb-8">
            <span className="inline-block px-3 py-1.5 rounded-full text-xs font-bold mb-3" style={{ background: 'rgba(212,175,55,0.12)', color: '#C58B19' }}>📅 Rétroplanning</span>
            <h2 className="font-display text-2xl sm:text-3xl font-bold" style={{ color: 'var(--ink)', letterSpacing: '-0.02em' }}>12 mois pour organiser votre Jour J</h2>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {RETRO.map((r, i) => (
              <div key={i} className="card-premium p-5">
                <div className="flex items-center gap-2 mb-3">
                  <span className="w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0"
                    style={{ background: '#D4AF37', color: '#0B1E20' }}>{i + 1}</span>
                  <p className="font-bold text-sm" style={{ color: 'var(--ink)' }}>{r.mois}</p>
                </div>
                <ul className="space-y-1.5">
                  {r.items.map((item, j) => (
                    <li key={j} className="flex items-start gap-2 text-xs" style={{ color: 'var(--text-muted)' }}>
                      <Check size={11} style={{ color: '#D4AF37', flexShrink: 0, marginTop: 2 }} /> {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CHECKLIST */}
      <section className="section-py" style={{ background: 'var(--bg)' }}>
        <div className="container-ose">
          <div className="text-center mb-8">
            <span className="inline-block px-3 py-1.5 rounded-full text-xs font-bold mb-3" style={{ background: 'rgba(31,157,122,0.12)', color: '#1F9D7A' }}>✅ Checklist mariage</span>
            <h2 className="font-display text-2xl font-bold" style={{ color: 'var(--ink)', letterSpacing: '-0.02em' }}>Ne rien oublier pour votre Jour J</h2>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {CHECKLIST.map(cat => {
              const catItems = checkItems.filter(i => i.cat === cat.cat);
              const done = catItems.filter(i => i.done).length;
              return (
                <div key={cat.cat} className="card-premium p-5">
                  <div className="flex items-center justify-between mb-3">
                    <p className="font-bold text-sm" style={{ color: 'var(--ink)' }}>{cat.cat}</p>
                    <span className="text-xs font-bold" style={{ color: '#D4AF37' }}>{done}/{catItems.length}</span>
                  </div>
                  {catItems.map((item) => (
                    <button key={item.label} onClick={() => setCheckItems(prev => prev.map(i => i.label === item.label && i.cat === item.cat ? { ...i, done: !i.done } : i))}
                      className="w-full flex items-start gap-2 p-1.5 rounded-lg text-left mb-1"
                      style={{ background: item.done ? 'rgba(31,157,122,0.06)' : 'transparent', border: 'none', cursor: 'pointer' }}>
                      <div className="w-4 h-4 rounded border-2 flex items-center justify-center flex-shrink-0 mt-0.5"
                        style={{ borderColor: item.done ? '#1F9D7A' : 'var(--border)', background: item.done ? '#1F9D7A' : 'transparent' }}>
                        {item.done && <Check size={9} color="white" />}
                      </div>
                      <span className="text-xs" style={{ color: item.done ? 'var(--text-muted)' : 'var(--ink)', textDecoration: item.done ? 'line-through' : 'none' }}>{item.label}</span>
                    </button>
                  ))}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* PLANNING JOUR J */}
      <section className="section-py section-white">
        <div className="container-ose max-w-2xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="font-display text-2xl font-bold" style={{ color: 'var(--ink)' }}>Déroulé type Jour J</h2>
          </div>
          {[
            ['09h00', 'Maquillage, coiffure, préparatifs', '#D4AF37'],
            ['11h00', 'Livraison & installation Show Événement', '#D4AF37'],
            ['14h00', 'Cérémonie civile', '#5DBCBF'],
            ['15h30', 'Séance photos officielles', '#5DBCBF'],
            ['17h00', 'Vin d\'honneur — animations, photobooth', '#1F9D7A'],
            ['19h30', 'Ouverture du repas', '#F4A7B2'],
            ['21h00', 'Discours, animations', '#D4AF37'],
            ['22h00', 'Ouverture de la piste & DJ', '#8B5CF6'],
            ['00h00', 'Pièce montée, minuit', '#F4A7B2'],
            ['02h00', 'Reprise matériel Show Événement (si nuit)', '#D4AF37'],
          ].map(([h, label, color], i) => (
            <div key={i} className="flex items-start gap-4 p-3 rounded-xl mb-2" style={{ background: '#FFF', border: '1px solid var(--border)' }}>
              <span className="font-bold text-sm w-14 flex-shrink-0" style={{ color }}>{h}</span>
              <p className="text-sm" style={{ color: 'var(--ink)' }}>{label}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ERREURS */}
      <section className="section-py" style={{ background: 'var(--bg)' }}>
        <div className="container-ose">
          <div className="text-center mb-8">
            <h2 className="font-display text-2xl font-bold" style={{ color: 'var(--ink)' }}>6 erreurs fréquentes</h2>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {ERREURS.map((e, i) => (
              <div key={i} className="card-premium p-5">
                <AlertTriangle size={16} style={{ color: '#F59E0B', marginBottom: 8 }} />
                <p className="font-bold text-sm mb-1" style={{ color: 'var(--ink)' }}>{e.e}</p>
                <p className="text-xs" style={{ color: 'var(--text-muted)', lineHeight: '1.6' }}>{e.c}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PRESTATAIRES */}
      <section className="section-py section-white">
        <div className="container-ose">
          <div className="text-center mb-8">
            <h2 className="font-display text-2xl font-bold" style={{ color: 'var(--ink)' }}>Prestataires recommandés</h2>
          </div>
          <div className="grid sm:grid-cols-2 gap-4 max-w-2xl mx-auto">
            <div className="card-premium p-5" style={{ borderLeft: '3px solid #D4AF37' }}>
              <p className="text-2xl mb-2">📸</p>
              <p className="font-bold text-sm mb-1" style={{ color: 'var(--ink)' }}>Photographe</p>
              <p className="text-xs mb-2" style={{ color: 'var(--text-muted)' }}>Laurie Gerling Photographie — style naturel et lumineux. Lot & Aveyron.</p>
              <a href="https://www.laurieg-photographie.com/" target="_blank" rel="noopener noreferrer"
                className="text-xs font-bold" style={{ color: '#D4AF37' }}>Voir son site →</a>
            </div>
            {[['🎵', 'DJ / Groupe live', 'Réserver 6-12 mois à l\'avance. Notre réseau de DJ locaux disponible sur demande.'],
              ['🌸', 'Fleuriste', 'Compositions fraîches sur commande. À contacter 4 semaines avant.'],
              ['🎬', 'Vidéaste', 'Aftermovie mariage souvenir. À réserver en même temps que le photographe.']
            ].map(([emoji, label, desc], i) => (
              <div key={i} className="card-premium p-5">
                <p className="text-2xl mb-2">{emoji}</p>
                <p className="font-bold text-sm mb-1" style={{ color: 'var(--ink)' }}>{label}</p>
                <p className="text-xs" style={{ color: 'var(--text-muted)' }}>{desc}</p>
              </div>
            ))}
          </div>
          <div className="text-center mt-6">
            <Link to="/prestataires-recommandes" className="inline-flex items-center gap-2 px-6 py-3 rounded-xl font-bold text-sm"
              style={{ background: '#0B1E20', color: '#D4AF37' }}>
              Voir tous nos prestataires <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </section>

      {/* CTA SHOW ÉVÉNEMENT */}
      <section className="section-py" style={{ background: '#0B1E20' }}>
        <div className="container-ose text-center">
          <h2 className="font-display text-2xl sm:text-3xl font-bold mb-4" style={{ color: '#FFF' }}>Show Événement s'occupe de tout le matériel</h2>
          <p className="text-sm mb-8 max-w-xl mx-auto" style={{ color: 'rgba(255,255,255,0.6)' }}>
            Photobooth, éclairage, arche ballons, coin enfants, sono — livraison et installation Jour J,
            reprise nocturne possible. Rayon 1h30 autour de Figeac.
          </p>
          <Link to="/creer-evenement"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-xl font-bold text-base"
            style={{ background: '#D4AF37', color: '#0B1E20', boxShadow: '0 12px 40px rgba(212,175,55,0.35)' }}>
            Créer mon devis mariage <ArrowRight size={18} />
          </Link>
        </div>
      </section>

      <Footer />
      <MobileStickyBar />
    </div>
  );
}
